export const firebaseConfig = {
  apiKey: "AIzaSyAqp11-HM6PVImdjapAtxUujezljqM72TY",
  authDomain: "livequiz-19ab2.firebaseapp.com",
  databaseURL: "https://livequiz-19ab2.firebaseio.com",
  projectId: "livequiz-19ab2",
  storageBucket: "livequiz-19ab2.appspot.com",
  messagingSenderId: "843672384988",
  appId: "1:843672384988:web:2bd6aec474448e50fdcb19",
  measurementId: "G-X12GCDLE3R"
};